import { Box, Button, CircularProgress, Stack } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { isMac } from "hooks/usePlatform";
import { HotkeyId } from "components/scrapEyeDataDashboard/VideoPlayer/contexts/HotkeyContext";
import { KeyIndicator } from "../../components/KeyIndicator";

const SAVE_SHORTCUT = isMac ? "⌘ + ⏎" : "Ctrl + ⏎";

interface ActionButtonsSectionProps {
  onSave?: () => void;
  saveBusy?: boolean;
  onDelete?: () => void;
  getDisplayKey: (key: HotkeyId) => string;
}

export const ActionButtonsSection = ({
  onSave,
  saveBusy = false,
  onDelete,
  getDisplayKey,
}: ActionButtonsSectionProps) => {
  const { t } = useTenantTranslation();

  if (!onSave && !onDelete) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
      {!!onDelete && (
        <Button onClick={onDelete} color="error" variant="outlined" fullWidth>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {t("delete")}
            <KeyIndicator
              keyLabel={getDisplayKey("deleteEvent")}
              variant="light"
            />
          </Box>
        </Button>
      )}
      {!!onSave && (
        <Button
          onClick={onSave}
          variant="contained"
          fullWidth
          disabled={saveBusy}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {saveBusy && <CircularProgress size={16} color="inherit" />}
            {t("save")}
            <KeyIndicator keyLabel={SAVE_SHORTCUT} variant="dark" />
          </Box>
        </Button>
      )}
    </Stack>
  );
};
